import React from 'react';
import { Dialog, DialogContent, Button, withStyles, Radio } from "@material-ui/core";
import modalBgImg from "../../../../assets/img/talent_profile_modal_back_small-min.png";
import logo from "../../../../assets/img/logo-black.png";
import { request } from '../../../../api-client';
import localization from '../../../../config/localization';
import AsyncSelect from "react-select/lib/Async";

const styles = {
  dialogPaper: {
      minHeight: '80vh',
      maxHeight: '80vh',
      backgroundColor: '#EFEFEF',
      borderRadius: '10px',
      padding: '40px',
      height: '80vh'
  },
  dialogPaperMobile: {
    minHeight: '80vh',
    maxHeight: '80vh',
    backgroundColor: '#EFEFEF',
    borderRadius: '10px',
    padding: '20px',
    height: '80vh',
    fontSize: '0.8em'
  }
};

const ModalButton = withStyles({
  root: {
    backgroundColor: 'black',
    color: 'white',
    minHeight: '30px',
    textTransform: 'none',
    padding: '5px 30px',
    '&:hover': {
      backgroundColor: 'black'
    },
    '&:disabled': {
      backgroundColor: 'grey',
      color: 'lightgrey'
    }
  },
})(Button);

class TalentProfileModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      isEditing: this.props.isEditing,
      currentStep: this.props.isEditing ? 2 : 1,
      selectedContentCreatorType: '',
      selectedContentCreatorTypeBrand: 'bloomclouds'
    };
  }


  renderStep = () => {
    switch (this.state.currentStep) {
      case 2:
        return this.renderStep2();
      case 3:
        return this.renderStep3();
      default:
        return this.renderFirstStep();
    }
  }

  renderFirstStep = () => {
    const steps = [localization.get("talent_profile_modal.step_1.item_1"), localization.get("talent_profile_modal.step_1.item_2"), localization.get("talent_profile_modal.step_1.item_3")];
    return (
      <DialogContent style={{padding: '0', height: '100%'}}>
        <div className="modal-step-container">
          <div className="modal-step-content">
            <div className="modal-title">{localization.get('talent_profile_modal.step_1.title')}</div>

            <div className="modal-subtitle">{localization.get('talent_profile_modal.step_1.subtitle')}</div>
            <div style={{paddingBottom: '10px'}}>
              {steps.map((item, index) => (
                <div className="modal-subtitle-item" key={`modal-step-${index}`}>{`${index+1}. ${item}`}</div>
              ))}
            </div>

            <div className="modal-text" style={{fontSize: '1.1em'}}>{localization.get("talent_profile_modal.step_1.text")}</div>

            {/* <div className="modal-text">{localization.get("talent_profile_modal.step_1.logo_text")}</div> */}

            <div style={{paddingTop: 20}}>
              <img src={logo} height="20px"/>
            </div>
          </div>
          <div className="modal-step-buttons" style={{justifyContent: 'flex-end'}}>
            <ModalButton onClick={() => this.setState({currentStep: 2})}>{localization.get("talent_profile_modal.step_1.button")}</ModalButton>
          </div>
        </div>
      </DialogContent>
    );
  }

  renderStep2 = () => {
    let isMobile = window.innerWidth < 450;
    const handleChange = (event) => {
      this.setState({selectedContentCreatorTypeBrand: null, currentBrand: event.target.value, selectedContentCreatorType: ''}, () => this.setState({selectedContentCreatorTypeBrand: this.state.currentBrand, currentBrand: null}));
    };

    const CustomRadio = withStyles({
      root: {
        color: 'black',
        width: '30px',
        justifyContent: 'flex-start',
        '&$checked': {
          color: 'black',
        },
      },
      checked: {},
    })((props) => <Radio color="default" {...props} />);

    return (
      <DialogContent style={{padding: '0', height: '100%'}}>
        <div className="modal-step-container">
          <div className="modal-step-content">
            <div className="modal-title">{this.props.isEditing ? localization.get("talent_profile_modal.step_2.editing_title") : localization.get("talent_profile_modal.step_2.title")}</div>
            <div style={isMobile ? {display: 'flex', flexDirection: 'column'} : {display: 'grid', gridTemplateColumns: '25% 25% 50%'}}>
              <div className="col-1" style={{display: 'flex', flexDirection: 'column'}}>
                <div style={{fontWeight: 'bold'}}>
                  <CustomRadio
                    checked={this.state.selectedContentCreatorTypeBrand === 'bloomclouds'}
                    onChange={(e) => handleChange(e)}
                    value="bloomclouds"
                    size="small"
                    name="selected-category-group"
                    inputProps={{ 'aria-label': localization.get('talent_profile_modal.content_creator_brand_full.bloomclouds') }}
                  />
                  {/* Creator */}
                  {localization.get('talent_profile_modal.content_creator_brand_full.bloomclouds')}
                </div>
                <div style={isMobile ? {display: 'none'} : {fontSize: '12px', paddingLeft: '30px', lineHeight: '16px'}}>
                  <p style={{fontWeight: 'bold', lineHeight: '21px'}}>{localization.get('talent_profile_modal.example')}:</p>
                  {[
                    localization.get('talent_profile_modal.brand7'),
                    localization.get('talent_profile_modal.brand8'),
                    localization.get('talent_profile_modal.brand9'),
                    localization.get('talent_profile_modal.brand10'),
                    localization.get('talent_profile_modal.brand11'),
                    localization.get('talent_profile_modal.brand12'),
                    'etc.'].map(e => <p key={`example-c-item-${e}`}>{e}</p>)}
                </div>
              </div>
              <div className="col-2" style={{display: 'flex', flexDirection: 'column'}}>
                <div style={{fontWeight: 'bold'}}>
                  <CustomRadio
                    checked={this.state.selectedContentCreatorTypeBrand === 'bigCreator'}
                    onChange={(e) => handleChange(e)}
                    value="bigCreator"
                    size="small"
                    name="selected-category-group"
                    inputProps={{ 'aria-label': localization.get('talent_profile_modal.content_creator_brand_full.bigCreator') }}
                  />
                  {/* Big Creator (Empresa) */}
                  {localization.get('talent_profile_modal.content_creator_brand_full.bigCreator')}
                </div>
                <div style={isMobile ? {display: 'none'} : {fontSize: '12px', paddingLeft: '30px', lineHeight: '16px'}}>
                  <p style={{fontWeight: 'bold', lineHeight: '21px'}}>{localization.get('talent_profile_modal.example')}:</p>
                  {[
                    localization.get('talent_profile_modal.brand1'),
                    localization.get('talent_profile_modal.brand2'),
                    localization.get('talent_profile_modal.brand3'),
                    localization.get('talent_profile_modal.brand4'),
                    localization.get('talent_profile_modal.brand5'),
                    localization.get('talent_profile_modal.brand6'),
                    'etc.'].map(e => <p key={`example-bc-item-${e}`}>{e}</p>)}
                </div>
              </div>
              <div className="col-3" style={{display: 'flex', flexDirection: 'column', marginTop: isMobile ? '10px' : 0}}>
                {this.state.selectedContentCreatorTypeBrand && this.renderAsyncSelect()}
              </div>
            </div>
          </div>
          <div className="modal-step-buttons" style={this.props.isEditing ? {justifyContent: 'space-between'} : {justifyContent: 'flex-end'}}>
            {this.props.isEditing && <Button onClick={() => this.handleModalClose()}>{localization.get("talent_profile_modal.step_2.cancel_button")}</Button>}
            <ModalButton disabled={!this.state.selectedContentCreatorType} onClick={() => this.setState({currentStep: 3})}>{localization.get("talent_profile_modal.step_2.button")}</ModalButton>
          </div>
        </div>
      </DialogContent>
    );
  }

  renderAsyncSelect = () => (
    <AsyncSelect
      styles={{
        menu: base => ({
          ...base,
          zIndex: 10,
          height: '150px'
        }),
        menuList: base => ({
          ...base,
          height: '150px',
        }),
        menuPortal: base => ({
          ...base,
          height: '150px',
        })
      }}
      theme={theme => ({
        ...theme,
        borderRadius: 5,
      })}
      placeholder={localization.get("talent_profile_modal.step_2.search_placeholder")}
      loadingMessage={() => localization.get('loading')}
      noOptionsMessage={() => localization.get('no_options')}
      onChange={(e) => {
        this.setState({selectedContentCreatorType: e});
      }}
      value={this.state.selectedContentCreatorType}
      defaultOptions
      isClearable={true}
      loadOptions={inputValue => {
        let filters = [{ column: "name", filter: inputValue }, {column: "brand", filter: this.state.selectedContentCreatorTypeBrand}, {column: "type", filter: 'talent'}];
        return request.contentCreatorType
          .getAll({filterBy: filters})
          .then(cct => cct.map(cct => ({...cct, value: cct.id, label: cct.name})))
          .then(categories => categories.sort((a, b) => a.label.localeCompare(b.label)))
        }
      }
    />
  );

  renderStep3 = () => {
    let brandString = localization.get(`talent_profile_modal.content_creator_brand.${this.state.selectedContentCreatorType.brand}`);
    return (
      <DialogContent style={{padding: '0', height: '100%'}}>
        <div className="modal-step-container">
          <div className="modal-step-content">
            <div className="modal-title">{localization.get("talent_profile_modal.step_3.title", this.state.selectedContentCreatorType.label, brandString)}</div>
            {this.props.isEditing && <div className="modal-text editing-text"><b style={{color: 'red'}}>{localization.get("talent_profile_modal.step_3.editing_bold_text")}</b> {localization.get("talent_profile_modal.step_3.editing_text")}</div>}
            <div className="modal-text" dangerouslySetInnerHTML={{ __html: localization.get("talent_profile_modal.step_3.text_1") }}/>
            <div className="modal-text" dangerouslySetInnerHTML={{ __html: localization.get("talent_profile_modal.step_3.text_2") }}/>
          </div>
          <div className="modal-step-buttons" style={{justifyContent: 'space-between'}}>
            <Button onClick={() => this.setState({currentStep: 2})}>{localization.get("talent_profile_modal.step_3.back_button")}</Button>
            <ModalButton onClick={() => this.handleModalEnd()}>{localization.get("talent_profile_modal.step_3.continue_button")}</ModalButton>
          </div>
        </div>
      </DialogContent>
    );
  }

  handleModalEnd = () => {
    this.props.onModalEnd && this.props.onModalEnd(this.state.selectedContentCreatorType);
    this.setState({open: false});
  }

  handleModalClose = () => {
    this.props.onModalClose && this.props.onModalClose();
    this.setState({open: false});
  }

  render = () => {
    const { classes } = this.props;
    let isMobile = window.innerWidth < 450;
    return (
      <Dialog
        disableEnforceFocus
        style={{zIndex: 999}}
        open={this.state.open} // TODO: add condition to showModal
        onEscapeKeyDown={this.handleModalClose}
        fullWidth
        classes={{paper: isMobile ? classes.dialogPaperMobile : classes.dialogPaper}}
        maxWidth="md"
      >
        <div style={{
          // minHeight: "225px",
          backgroundImage: `url(${modalBgImg})`,
          backgroundSize: 'cover',
          padding: isMobile ? '20px 10px' : '80px 50px',
          paddingBottom: isMobile ? '10px' : '20px',
          borderRadius: '10px',
          color: "black",
          height: '100%',
          overflow: 'auto'
        }}>
          {this.renderStep()}
        </div>
      </Dialog>
    );
  }
}

export default withStyles(styles)(TalentProfileModal);